import { defineMessages } from 'react-intl-next';
export default defineMessages({
  description: {
    id: 'link-create.unknown-error.description',
    defaultMessage: 'Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.',
    description: 'Description when an unknown error occurs'
  }
});